import React from 'react';
import { Link, makeStyles } from '@material-ui/core';

import { LabeledUrlField } from 'components/fields';
import { capitalize } from 'services/helpers/formatters';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
  },
}));

const formatInterceptionType = (interceptionType: string) =>
  capitalize(interceptionType.replace(/_/g, ' '));

const formatInterceptedAt = (interceptedAt: string) => {
  const date = new Date(interceptedAt);

  if (isNaN(date.getTime())) {
    return interceptedAt;
  }

  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  });
};

const ShipmentDetailsLink = ({ children, shipmentId }) => {
  if (!shipmentId) {
    return <span>{children}</span>;
  }

  return (
    <Link
      href={`/shipments/${shipmentId}/show`}
      target="_blank"
      rel="noopener noreferrer"
      underline="always"
      onClick={(event) => event.stopPropagation()}>
      {children}
    </Link>
  );
};

const TrackingNumberField = ({ record = {} }) => {
  const classes = useStyles();
  const { shipmentInfo } = record;

  return (
    <div className={classes.container}>
      <LabeledUrlField
        record={record}
        source="shipmentInfo.trackLink"
        labelSource="shipmentInfo.trackNumber"
        enableCopy
      />

      {!!shipmentInfo?.interceptionType && (
        <ShipmentDetailsLink shipmentId={shipmentInfo.id}>
          Interception: {formatInterceptionType(shipmentInfo.interceptionType)}
        </ShipmentDetailsLink>
      )}

      {!!shipmentInfo?.interceptedAt && (
        <ShipmentDetailsLink shipmentId={shipmentInfo.id}>
          Intercepted at: {formatInterceptedAt(shipmentInfo.interceptedAt)}
        </ShipmentDetailsLink>
      )}
    </div>
  );
};

export default TrackingNumberField;
